<template>
    <div class="home-service-wrapper">
        <HomeService2025></HomeService2025>
        <hr class="line-break">
        <HomeServicePack2025 :box="box"></HomeServicePack2025>
    </div>
</template>
<script>
import HomeService2025 from "./HomeService2025.vue";
import HomeServicePack2025 from "../_commons/nl/components2025/HomeServicePack2025.vue";

export default {
    name: "HomeServiceSection2024",
    components: {HomeServicePack2025, HomeService2025},
    props: {
        box: {
            type: String,
            default: 'list'
        },
    },
}
</script>
<style scoped>

</style>
